import { render, staticRenderFns } from "./BookingForm.vue?vue&type=template&id=9a1509d2&scoped=true"
import script from "./BookingForm.vue?vue&type=script&lang=ts"
export * from "./BookingForm.vue?vue&type=script&lang=ts"
import style0 from "./BookingForm.vue?vue&type=style&index=0&id=9a1509d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a1509d2",
  null
  
)

export default component.exports